import React from 'react';
import {formatNumber} from "../config/AppConfig";

function SortableCards() {
    return (
        <>
            <div className="divider pb-1 mb-4">
                <div className="divider-text display-1">
                    <h6 className="display-6">Netikash Subscribe en Chiffres</h6>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card mb-lg-0 mb-4">
                        <div className="card-body text-center">
                            <h2>
                                <i className="bx bx-cart text-success display-6"></i>
                            </h2>
                            <h4>Abonnements Mensuel</h4>
                            <h5>{formatNumber(943)}</h5>
                        </div>
                    </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card mb-lg-0 mb-4">
                        <div className="card-body text-center">
                            <h2>
                                <i className="bx bx-globe text-info display-6"></i>
                            </h2>
                            <h4>Total abonnements</h4>
                            <h5>{formatNumber(3258)}</h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card mb-lg-0 mb-4">
                        <div className="card-body text-center">
                            <h2>
                                <i className="bx bx-buildings text-danger display-6"></i>
                            </h2>
                            <h4>Organisations</h4>
                            <h5>{formatNumber(9)}</h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card mb-lg-0 mb-4">
                        <div className="card-body text-center">
                            <h2>
                                <i className="bx bx-user text-primary display-6"></i>
                            </h2>
                            <h4>Utilisateurs</h4>
                            <h5>{formatNumber(1086)}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SortableCards;